import { useState, useEffect } from 'react'
import { supabase } from '../../supabase'
import { useAuth } from '../../contexts/AuthContext'
import { formatEuro, MOIS_LABELS } from '../../utils/calculs'
import ColonnesFactures from '../../components/ColonnesFactures'
import './MonEspace.css'

export default function MonEspace() {
  const { profile } = useAuth()
  const now = new Date()
  const [annee, setAnnee] = useState(now.getFullYear())
  const [mois, setMois] = useState(now.getMonth() + 1)
  const [seances, setSeances] = useState([])
  const [accueil, setAccueil] = useState([])
  const [reunions, setReunions] = useState([])
  const [assistanat, setAssistanat] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!profile) return
    load()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [annee, mois, profile])

  async function load() {
    setLoading(true)
    const debut = `${annee}-${String(mois).padStart(2,'0')}-01`
    // Fix bug UTC : construction explicite sans toISOString()
    const dernierJour = new Date(annee, mois, 0).getDate()
    const fin = `${annee}-${String(mois).padStart(2,'0')}-${String(dernierJour).padStart(2,'0')}`

    const [{ data: seancesData }, { data: accueilData }, { data: reunionsData }, { data: assistanatData }] = await Promise.all([
      supabase.from('seances')
        .select('id, date, pole, total_massage_payant, total_massage_gratuit, remuneration_affichee, superviseur_id, superviseur2_id, partage_horaire, sup1_remuneration, sup2_remuneration, cloture')
        .or(`superviseur_id.eq.${profile.id},superviseur2_id.eq.${profile.id}`)
        .gte('date', debut).lte('date', fin).order('date'),
      supabase.from('seances_accueil')
        .select('id, date, montant, cloture')
        .eq('superviseur_id', profile.id)
        .gte('date', debut).lte('date', fin).order('date'),
      supabase.from('reunions_presences')
        .select('id, date, duree_heures, montant')
        .eq('superviseur_id', profile.id)
        .gte('date', debut).lte('date', fin).order('date'),
      // Assistanat : seules les journees validees par la coordination sont payees
      supabase.from('affectations')
        .select('id, date, montant, cours')
        .eq('type', 'ASSISTANAT').eq('statut', 'valide')
        .eq('superviseur_id', profile.id)
        .gte('date', debut).lte('date', fin).order('date')
    ])

    setSeances(seancesData || [])
    setAccueil(accueilData || [])
    setReunions(reunionsData || [])
    setAssistanat(assistanatData || [])
    setLoading(false)
  }

  function remunSeance(s) {
    if (!s.partage_horaire) return s.remuneration_affichee || 0
    return (s.superviseur_id === profile.id ? s.sup1_remuneration : s.sup2_remuneration) || 0
  }

  const totalSupervision = seances.reduce((a, s) => a + remunSeance(s), 0) + reunions.reduce((a, r) => a + (r.montant || 0), 0)
  const totalGeneral = totalSupervision
    + accueil.reduce((a, s) => a + (s.montant || 0), 0)
    + assistanat.reduce((a, r) => a + (r.montant || 0), 0)
  const rienDuTout = seances.length + accueil.length + reunions.length + assistanat.length === 0

  const annees = [2024, 2025, 2026, 2027]

  return (
    <div className="me-page">
      <div className="me-header">
        <div className="me-header-name">{profile?.prenom} {profile?.nom}</div>
        <div className="me-header-role">Superviseur</div>
      </div>

      <div className="me-filters">
        <select value={annee} onChange={e => setAnnee(+e.target.value)} className="me-select">
          {annees.map(a => <option key={a} value={a}>{a}</option>)}
        </select>
        <select value={mois} onChange={e => setMois(+e.target.value)} className="me-select">
          {MOIS_LABELS.slice(1).map((m, i) => <option key={i+1} value={i+1}>{m}</option>)}
        </select>
      </div>

      <div className="me-stats">
        <div className="me-stat-main">
          <div className="me-stat-label">Total à facturer</div>
          <div className="me-stat-value">{formatEuro(totalGeneral)}</div>
          <div className="me-stat-sub">{MOIS_LABELS[mois]} {annee}</div>
        </div>
      </div>

      {loading ? <div className="spinner" /> : rienDuTout ? (
        <div className="me-empty">Aucune activité pour {MOIS_LABELS[mois]} {annee}</div>
      ) : (
        <ColonnesFactures seances={seances} accueil={accueil} reunions={reunions} assistanat={assistanat} remunSeance={remunSeance} />
      )}
    </div>
  )
}
